import { ScgpExportOrderStatusSap } from "@saleor/graphql";

export enum FIELD_TYPE {
  DISABLED_TEXT = "DISABLED_TEXT",
  SINGLE_INPUT = "SINGLE_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  SUGGESTION_INPUT = "SUGGESTION_INPUT",
  RADIO_GROUP = "RADIO_GROUP",
  DATEPICKER = "DATEPICKER",
  MULTIPLE_SELECT = "MULTIPLE_SELECT",
  MULTIPLE_SUGGESTION_INPUT = "MULTIPLE_SUGGESTION_INPUT",
  BUTTON_SHIP_TO = "BUTTON_SHIP_TO",
  EMPTY = "EMPTY"
}

export const orderTypeChoices = [
  { label: "All", value: "ALL" },
  { label: "Complete", value: ScgpExportOrderStatusSap.COMPLETE },
  { label: "Being Process", value: ScgpExportOrderStatusSap.BEING_PROCESS }
];

export interface SubmitFilterDataType {
  soldTo?: string;
  materialCodeName?: string;
  soNo?: string;
  contractNo?: string;
  saleGroup?: string;
  bu?: string;
  company?: string;
  statusSAP?: string;
  saleEmployee?: string;
  orderType?: string;
  invoiceNo?: string;
  dpNo?: string;
  dateSelectionType?: DateSelectionType;
  createDate?: {
    gte: string;
    lte: string;
  };
  lastUpdate?: {
    gte: string;
    lte: string;
  };
}

export enum DateSelectionType {
  CREATE_DATE = "CREATE_DATE",
  LAST_UPDATE = "LAST_UPDATE"
}
export enum StatusSelectionType {
  ALL = "ALL",
  PENDING = "PENDING",
  COMPLETE = "COMPLETE"
}
